module.exports = __webpack_public_path__ + "static/media/question-button-press-b.b4c972d4.png";